import React, { useRef } from 'react'

import {
  usePopover,
  useCombinedRefs,
  useFocusTrapping,
  useOnClickOutside,
} from '@/hooks'

interface Props {
  currentState: boolean
  children: React.ReactNode
}

const Content: React.FC<Props> = ({ children, currentState }) => {
  const { closeOnOutside, onClose } = usePopover()
  const ref = useRef<HTMLDialogElement>(null)

  const refFocusTrapping = useFocusTrapping()
  const mergedRef = useCombinedRefs(ref, refFocusTrapping)

  useOnClickOutside(mergedRef, closeOnOutside && currentState, onClose)

  return (
    <div className="submenu" ref={mergedRef}>
      {children}
    </div>
  )
}

export default Content
